import type { AddressSuggestion } from '@@partner:types:app'

import { useState, useEffect } from 'react'
import { useQuery } from '@apollo/client'

import { GQL_QUERY_GET_ADDRESS_SUGGESTIONS } from '@@partner:graphql/query/getAddressSuggestions.gql'

export default function useAddressSuggestions (address: string) {
  const [ suggestions, setSuggestions ] = useState<AddressSuggestion[]>([])
  const { data, loading, error } = useQuery(GQL_QUERY_GET_ADDRESS_SUGGESTIONS, {
    variables: {
      address
    },
    skip: address.length < 3
  })

  useEffect(() => {
    if (data) {
      setSuggestions(data.getAddressSuggestions.suggestions)
    }
  }, [ address, data ])

  return {
    suggestions,
    suggestionsValues: suggestions.map((obj) => obj.value),
    clearSuggestions: () => setSuggestions([]),
    loading,
    error
  }
}
